import type { Epic } from '../../index.ts'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.ts'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { SystemMessages } from '../../../Generated/SystemMessages.ts'

export const LoadSystemMessagesEpic: Epic = (action$, state$, { [applicationSlice.name]: application, ApplicationRepository }) =>
  action$.pipe(
    filter(application.loadSystemMessages.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      ApplicationRepository.loadSystemMessages(action.payload.all).pipe(
        mergeMap((response: SystemMessages[]) => of(application.loadSystemMessagesSuccess(response))),
        catchError((error) => of(application.loadSystemMessagesFailure(error as Error)))
      )
    )
  )
